import Vue from 'vue'
import VueResource from 'vue-resource'
import { container } from '../services/container'
Vue.use(VueResource)
import { CachedApi } from './CachedApi'

export class WeekPlanApi {
	constructor () {
		this.url = process.env.VUE_APP_API_URL
		this.access_token = container.get('services.oauth').getToken()
	}

	/**
	 * Get current menu
	 *
	 * @param {mixed} key
	 *
	 * @return {Promise}
	 */
	current (params) {

		let c = new CachedApi();
		params.source = container.get('source').getValue()

		return c.get(this.url + '/menu', params);
	}

	next () {
		return Vue.http.get(this.url + '/menu/next', { headers: {
			Authorization: 'Bearer ' + this.access_token
		}})
	}
  
  available () {
    return Vue.http.get(this.url + '/menu/available', { headers: {
      Authorization: 'Bearer ' + this.access_token
    }})
  }

	prev () {
		return Vue.http.get(this.url + '/menu/prev', { headers: {
			Authorization: 'Bearer ' + this.access_token
		}})
	}

	week (params) {
		this.url = process.env.NODE_ENV === 'development'
    			? 'https://sigma.quomi.it:8214/v1'
        		: process.env.VUE_APP_API_URL
		return Vue.http.get(this.url + '/menu/' + params.id)
	}
}
